var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2360_869",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2360_869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 22V4C2.5 3.45 2.69583 2.97917 3.0875 2.5875C3.47917 2.19583 3.95 2 4.5 2H20.5C21.05 2 21.5208 2.19583 21.9125 2.5875C22.3042 2.97917 22.5 3.45 22.5 4V16C22.5 16.55 22.3042 17.0208 21.9125 17.4125C21.5208 17.8042 21.05 18 20.5 18H6.5L2.5 22ZM5.65 16H20.5V4H4.5V17.125L5.65 16Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWhite);
export default __webpack_public_path__ + "static/media/message-white.f15165004f514b4cce034615eb8c9b74.svg";
export { ForwardRef as ReactComponent };